'use client';

import { NestedStatusEnum } from '@/config/steps.config';
import clsx from 'clsx';
import { useSearchParams } from 'next/navigation';
import Tag from '@repo/ui/Tag';
import { SessionProvider } from 'next-auth/react';
import { Session } from 'next-auth';

interface MainTagWrapperProps extends React.HTMLAttributes<HTMLElement> {
  session?: Session | null;
}

const MainTagWrapper = ({
  children,
  className,
  session = null,
  ...rest
}: MainTagWrapperProps) => {
  const searchParams = useSearchParams();
  const isNested = searchParams.get(NestedStatusEnum.NESTED) !== null;
  const SemTag = isNested ? 'main' : 'div';

  return (
    <SessionProvider session={session}>
      <Tag
        tagName={SemTag}
        className={clsx(
          'flex-grow flex flex-col is-full max-is-[40rem] mli-auto pli-4',
          className,
        )}
        {...rest}
      >
        {children}
      </Tag>
    </SessionProvider>
  );
};

export default MainTagWrapper;
